import * as React from 'react';
import { TooltipDesktop, ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';
import { IconProductSalesStart12 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SalesStartTooltip.css';

export const SalesStartTooltip = () => {
  return (
    <TooltipDesktop
      title={
        <>
          <ArticleHeading4>Старт продаж корпуса</ArticleHeading4>
          <ArticleParagraph2>Есть выгодные предложения и скидки</ArticleParagraph2>
        </>
      }
      theme="white"
      placement="right-start"
    >
      <span className={styles['icon']}>
        <IconProductSalesStart12 color="icon-negative-default" data-testid="StartSales12Icon" />
      </span>
    </TooltipDesktop>
  );
};
